<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
            <a routerLink="/wholesalers" style="color: #003E53;">Wholesalers</a>
        </li>

        <li class="breadcrumb-item active" aria-current="page">
            Assign Retailers
        </li>
    </ol>
</nav>
<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center mb-3 gx-2">
                <!-- Title Section -->
                <div class="col-12 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">
                        Distributors Under : {{ singleDistributor?.name }}
                    </h5>
                </div>

                <!-- Buttons Section -->
                <div class="col-12 col-md-6 d-flex justify-content-end gap-2 mt-2 mt-md-0">
                    <button type="button" class="btn btn-sm btn-primary" (click)="openModel(1)">
                        Assign Wholesaler
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="openModel(2)">
                        Assign Retailer
                    </button>

                </div>
            </div>

            <hr>

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element">
                                <div (click)="openRetailerDetailModel(element.distributorId._id)" class="link "
                                    title="View Detail">
                                    {{element.distributorId.name}} <br>
                                    <small style="color:#006B88 !important;"
                                        class="fw-bold mt-3">{{element?.distributorType===1?'WHOLESALER':'RETAILER'}}</small>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.distributorId.email}} </td>
                        </ng-container>
                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef> Phone </th>
                            <td mat-cell *matCellDef="let element"> {{element.distributorId.phone}} </td>
                        </ng-container>
                        <ng-container matColumnDef="cordinates">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Coordinates (Lng, Lat)
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.distributorId?.location?.coordinates[0] }}<br>
                                {{ element.distributorId?.location?.coordinates[1] }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 200px;">Address</th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div style="width: 200px; white-space: normal; word-wrap: break-word;">
                                    {{ element.distributorId?.address }},
                                    <br>
                                    {{ element.distributorId?.city }},
                                    {{element.distributorId?.state }}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 200px;">Action</th>
                             <td mat-cell *matCellDef="let element" class="text-center">
                                @if(userDataService?.roleMatch(['REMOVED-ASSIGNED-DISTRIBUTOR'])){
                                  <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                      <mat-icon class="c_btn" (click)="removeAssignDistributor(element)">delete_outline</mat-icon>
                                  </div>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <mat-paginator #paginator [length]="total" [pageSize]="10" (page)="getAllRetailers($event)"></mat-paginator>
        </app-card>
    </div>
</div>





<!-- Modal -->
<div class="modal fade" id="assignRTLModal" tabindex="-1" aria-labelledby="assignRTLModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="assignRTLModalLabel">
                    Assign
                    @if (distributorType === 1) {
                    Wholesaler
                    } @else {
                    Retailer
                    }
                    to {{ singleDistributor?.name }}
                </h5>

                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>
            <div class="modal-body pt-1">

                <div class="col-12 col-md-12 col-lg-12">
                    <ng-select [items]="allCompanyDistributorsMini" bindLabel="distributorId.name"
                        [(ngModel)]="selectedRetailer" (ngModelChange)="selectedRTL($event)"
                        placeholder="Select Retailer">
                    </ng-select>

                </div>

            </div>
        </div>
    </div>
</div>



<!-- Modal -->
<div class="modal fade" id="retailerDetailModal" tabindex="-1" aria-labelledby="retailerDetailModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="retailerDetailModalLabel">Retailer Profile</h5>
                <button type="button" class="btn-close" (click)="hideRetailerDetailModel()"></button>
            </div>
            <div class="modal-body pt-1">
                @if (singleRetailer) {


                <div class="row g-2">
                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Store Name:</label>
                        <div>{{ singleRetailer?.name }}</div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Phone:</label>
                        <div>{{ singleRetailer?.phone }}</div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Email:</label>
                        <div>{{ singleRetailer?.email }}</div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-semibold">GST No:</label>
                        <div>{{ singleRetailer?.gstNo }}</div>
                    </div>

                    <div class="col-md-12">
                        <label class="form-label fw-semibold">Address:</label>
                        <div>
                            {{ singleRetailer?.address }}, {{ singleRetailer?.city }}, {{ singleRetailer?.state }}
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Latitude:</label>
                        <div>{{ singleRetailer?.latitude }}</div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label fw-semibold">Longitude:</label>
                        <div>{{ singleRetailer?.longitude }}</div>
                    </div>

                    @if (singleRetailer?.image) {
                    <div class="col-md-12 text-center mt-3">
                        <img [src]="singleRetailer?.image" class="rounded border" alt="Profile"
                            style="max-height: 150px;">
                    </div>
                    }
                </div>
                } @else {
                <div class="text-center text-muted py-4">
                    Retailer data not available.
                </div>
                }
            </div>

        </div>
    </div>
</div>
